import Marked from "./Markdown";
import {isEmpty} from "@/utils/tools";

/**
 * 剧本内容预定义标签替换，表情文字等
 * @param text
 * @returns {*}
 */
export const contentRender = (text: string):string => {
  if (isEmpty(text)) return "";
  let detail = text;
  detail = detail.replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;")
  // 将内容中的|||替换成换行，做换行处理
  detail = detail.replace(/\|\|\|/g, "\n");
  // 替换表情
  detail = detail.replace(
    /\[@(.+?)@\]/g,
    '<img class="page-content-emotion" src="/images/emotion/$1.png"/>'
  );
  // 替换a标签
  detail = detail.replace(
    /<(l|I|L|i)mc9>(.+?)<\/\1mc9>/g,
    '<a class="page-content-color9" href="$2" target="_blank">$2</a>'
  );
  // 替换其他颜色文字<lcm1></lcm1>等
  detail = detail.replace(
    /<(l|I|L|i)mc(.+?)>(.+?)<\/\1mc(.+?)>/g,
    '<span class="page-content-color$2">$3</span>'
  );
  // 替换斜体文字<lcmi></lcmi>等
  detail = detail.replace(
    /<(l|I|L|i)mi>(.+?)<\/\1mi>/g,
    '<span class="page-content-italic">$2</span>'
  );
  // 替换加粗文字<lcms></lcms>等
  detail = detail.replace(
    /<(l|I|L|i)ms>(.+?)<\/\1ms>/g,
    '<span class="page-content-strong">$2</span>'
  );
  // 替换es标签（对这句话词句的解释）
  detail = detail.replace(
    /<ex>(.+?)<\/ex>/g,
    '<span class="page-content-ex">$1</span>'
  );
  const marker = new Marked({lineNumbers: false, getHeadingId: (s => s)});
  detail = marker.render(detail);
  return detail.replace(/\n+/g, "<br />");
};
